<template>
    <div class="billing-hub-toolbar border-b border-ultralight bg-surface-raised">
        <div v-on-clickaway="closeSectionMenu" class="billing-hub-section-select relative flex min-w-0 flex-shrink-0 items-center border-r border-ultralight">
            <button
                :aria-expanded="sectionMenuOpen ? 'true' : 'false'"
                aria-haspopup="listbox"
                class="billing-hub-section-trigger relative flex h-full min-w-[18rem] max-w-[26rem] items-center bg-surface-raised py-0 pl-5 pr-10 text-left text-sm font-medium leading-5 text-gray-800 focus:outline-none"
                type="button"
                @click="sectionMenuOpen = !sectionMenuOpen"
            >
                <span class="billing-hub-section-icon-frame mr-3">
                    <svg-vue :icon="currentSection.icon" :class="currentSection.iconClass" class="billing-hub-section-icon text-gray-400"/>
                </span>
                <span class="min-w-0 flex-1 truncate">{{ currentSection.label }}</span>
                <svg-vue class="absolute right-4 h-[0.875rem] w-[0.875rem] text-gray-900" icon="font-awesome.regular.angle-down"/>
            </button>

            <div v-show="sectionMenuOpen" class="billing-hub-section-menu absolute left-0 top-full mt-2 min-w-full overflow-hidden rounded border border-bordergray-100 bg-white shadow-lg" role="listbox">
                <button
                    v-for="section in sectionOptions"
                    :key="section.value"
                    :aria-selected="activeSection === section.value ? 'true' : 'false'"
                    :class="activeSection === section.value ? 'bg-gray-50 font-semibold text-gray-900' : 'font-normal text-gray-700 hover:bg-gray-50'"
                    class="flex w-full min-w-0 items-center px-4 py-2 text-left text-sm"
                    role="option"
                    type="button"
                    @click="selectSection(section)"
                >
                    <span class="billing-hub-section-icon-frame mr-3">
                        <svg-vue :icon="section.icon" :class="section.iconClass" class="billing-hub-section-icon text-gray-400"/>
                    </span>
                    <span class="min-w-0 flex-1 truncate">{{ section.label }}</span>
                </button>
            </div>
        </div>

        <button :aria-label="createLabel" class="billing-hub-create btn-stage-icon-plain" :title="createLabel" type="button" @click="$emit('create')">
            <svg-vue class="h-4 w-4" icon="font-awesome.regular.plus"/>
        </button>
    </div>
</template>

<script>
export default {
    name: 'billing-hub-toolbar',
    emits: ['create'],
    props: {
        activeSection: {type: String, required: true},
        createLabel: {type: String, required: true},
    },
    data() { return {sectionMenuOpen: false}; },
    computed: {
        sectionOptions() {
            return [
                {value: 'accounts', label: 'Leistungskonten', icon: 'font-awesome.regular.box-arrow-down-arrow-up', iconClass: 'billing-hub-section-icon--account', path: '/workspace/service-accounts'},
                {value: 'profiles', label: 'Rechnungsanschriften', icon: 'font-awesome.regular.address-card', iconClass: 'billing-hub-section-icon--address', path: '/workspace/billing-profiles'},
                {value: 'banks', label: 'Bankverbindungen', icon: 'font-awesome.regular.building-columns', iconClass: 'billing-hub-section-icon--bank', path: '/workspace/bank-accounts'},
            ];
        },
        currentSection() { return this.sectionOptions.find((section) => section.value === this.activeSection) || this.sectionOptions[0]; },
    },
    methods: {
        closeSectionMenu() { this.sectionMenuOpen = false; },
        selectSection(section) {
            this.closeSectionMenu();
            if (!section || section.value === this.activeSection) return;
            this.$router.push(section.path);
        },
    },
};
</script>

<style scoped>
.billing-hub-toolbar { display: flex; height: 3.25rem; min-height: 3.25rem; align-items: stretch; justify-content: space-between; }
.billing-hub-section-select { min-width: 18rem; }
.billing-hub-section-trigger { width: 100%; }
.billing-hub-section-menu { z-index: 120; }
.billing-hub-section-icon-frame { display: inline-flex; width: 1.25rem; height: 1.25rem; flex: 0 0 1.25rem; align-items: center; justify-content: center; }
.billing-hub-section-icon { display: block; flex-shrink: 0; }
.billing-hub-section-icon--account { width: 1rem; height: 1rem; }
.billing-hub-section-icon--address { width: 1.125rem; height: 1.125rem; }
.billing-hub-section-icon--bank { width: 1rem; height: 1rem; }
.billing-hub-create {
    align-self: stretch;
    width: 3.25rem;
    height: auto;
    flex-shrink: 0;
    border-radius: 0;
    background: transparent;
    color: var(--stage-background-color-dark);
    transition: none;
}

.billing-hub-create:hover,
.billing-hub-create:focus,
.billing-hub-create:focus-visible,
.billing-hub-create:active {
    background: transparent;
    color: var(--stage-background-color-dark);
    box-shadow: none;
}

@media (max-width: 639px) {
    .billing-hub-section-select { min-width: 0; flex: 1; }
    .billing-hub-section-trigger { min-width: 0; }
}
</style>
